import { Button, Dialog, DialogActions, DialogTitle } from '@mui/material';
import { connect } from 'redux-bundler-react';
import { withStyles } from 'tss-react/mui';
import React from 'react';
import { Select, MenuItem, InputLabel, FormControl } from '@mui/material';
import moment from 'moment-timezone';

import Chart from '../../molecules/Chart/v2.jsx';
import MemoizedDataChart from './MemoizedDataChart';
import workstationStats from '../../../bundles/workstation_stats';

const styles = theme => ({
  dialog: {
    zIndex: 4000,
  },
});

const METRIC_NAME_MAP = {
  rtt_p50: 'DCV RTT (p50)',
  rtt_p90: 'DCV RTT (p90)',
  rtt_p99: 'DCV RTT (p99)',
  bandwidth_in: 'Bandwidth In',
  bandwidth_out: 'Bandwidth Out',
  frame_rate: 'Frame Rate',
  packet_loss: 'Packet Loss',
  // Add more known mappings here
};

const getFriendlyName = rawMetric => METRIC_NAME_MAP[rawMetric] || rawMetric;

const DcvMetrics = ({ classes, dcvMetrics, open, onClose }) => {
  const [processedMetrics, setProcessedMetrics] = React.useState(null);
  const [selectedMetric, setSelectedMetric] = React.useState('rtt_p50');

  React.useEffect(() => {
    if (open) {
      setTimeout(() => {
        const metricsMap = {};
        dcvMetrics.forEach(file => {
          const lines = file.fileData.trim().split('\n');
          console.log(lines);

          lines.forEach(line => {
            const parts = line.split(' ', 2); // Extract timestamp
            const timestamp = parts[0] + 'T' + parts[1].split(',')[0] + 'Z'; // Convert to ISO format
            const jsonData = line
              .substring(parts[0].length + parts[1].length + 1)
              .trim(); // Extract JSON

            try {
              const metrics = JSON.parse(jsonData);

              metrics.forEach(metric => {
                const metricName = metric.MetricName;

                const time = moment.utc(metric.Timestamp).valueOf();
                console.log(metricName);
                console.log(time);
                const value = metric.Value ?? metric.StatisticValues?.Sum ?? 0; // Use Value or Sum if present
                const maxValue = metric.StatisticValues?.Maximum ?? value; // Use Maximum if available, else Value

                if (!metricsMap[metricName]) {
                  metricsMap[metricName] = { data: [], max: -Infinity };
                }
                if (metricName == 'connection_duration') {
                  console.log(time, value);
                }

                metricsMap[metricName].data.push([time, value]);
                metricsMap[metricName].max = Math.max(
                  metricsMap[metricName].max,
                  maxValue,
                );
              });
            } catch (error) {
              console.error('Error parsing JSON:', error);
            }
          });
        });

        console.log(metricsMap);

        setProcessedMetrics(metricsMap);
      }, 0);
    }
  }, [dcvMetrics, open]);
  return (
    <Dialog
      maxWidth="sm"
      fullWidth
      aria-labelledby="confirmation-dialog-title"
      open={open}
      className={classes.dialog}
    >
      <DialogTitle className={classes.dialogTitle}>Metrics</DialogTitle>
      {processedMetrics && (
        <FormControl fullWidth style={{ padding: '16px' }}>
          <InputLabel id="metric-select-label">Metric</InputLabel>
          <Select
            labelId="metric-select-label"
            value={selectedMetric}
            label="Metric"
            onChange={e => setSelectedMetric(e.target.value)}
            MenuProps={{
              style: {
                zIndex: 4500,
              },
            }}
          >
            {Object.keys(processedMetrics).map(key => (
              <MenuItem key={key} value={key}>
                {getFriendlyName(key)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}

      {processedMetrics && selectedMetric && (
        <Chart
          dependantFormat={function() {
            return `${this.value}`;
          }}
          loading={false}
          units=" ms"
          height={100}
          title={getFriendlyName(selectedMetric)}
          maxDomain={processedMetrics[selectedMetric]?.max}
          data={[
            {
              name: getFriendlyName(selectedMetric),
              data: (processedMetrics[selectedMetric]?.data || []).sort(
                (a, b) => a[0] - b[0],
              ),
            },
          ]}
        />
      )}

      <DialogActions>
        <Button onClick={onClose} color="primary" autoFocus>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default connect(
  'selectRecipeQueryParameter',
  'selectActiveImagePipeline',
  withStyles(DcvMetrics, styles),
);
